import { useFormikContext } from "formik";
import React, { useEffect, useRef } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import { Link, useNavigate } from "react-router-dom";

export const SignUpSubmission = ({ isSubmitted }) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    let statusMessage = "";
    const navigate = useNavigate();

    if (status?.error === true) {
        statusMessage = (
            <p role="status" className="text-danger" >
                Error creating profile. <br /> This account may already exist.{" "}
                <br /> Try signing in.
            </p>
        );
    } else if (status?.error === false) {
        statusMessage = (
            <>
                <p role="status" id="status" className="text-success" style={{ "fontSize": "1.2rem" }}> 
                    Profile successfully created! </p> <p> You were sent a verification link associated with provided email.
                    Please click the link in your email to activate your account. If
                    you did not receive the link
                    <Button
                        variant="link"
                        onClick={ () => navigate("/request-account-verification")}
                    >
                        <i>click here to resend</i>
                    </Button>
                </p>
            </>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            
            {!isSubmitted && (
                <>
                    <Row className="mb-1">
                        <Col>
                            <Button
                                className="btn btn-primary"
                                type="submit"
                                disabled={isSubmitting}
                                aria-label="Sign up, click to create account"
                                aria-invalid={status?.error === true ? "true" : null}
                            >
                                Sign Up
                            </Button>
                        </Col>
                        <Col className="mt-2">
                            <Row>
                                <Link
                                    to="/signin"
                                    className="d-flex justify-content-end"
                                    aria-label="Sign in, click to go to sign in page"
                                >
                                    Sign in
                                </Link>
                            </Row>
                        </Col>
                    </Row>
                </>
            )}
            <Row>{statusMessage}</Row>
        </>
    );
};
